import { instanceOf } from 'prop-types'
import { Fragment } from 'react'

import getUsername from '../../../../utilities/getUsername.js'
import localizedPostTime from '../../../../utilities/localizedPostTime.js'
import Post from '../../../../../models/Post.js'
import Settings from '../../../../../models/settings.js'

export default function UserRealName({ post, settings }) {
  if (!post.userName && !post.userRealName) {
    return null
  }
  return (
    <div className="bzfy-c-tilegrid-post__profile-content-block bzfy-c-tilegrid-post__profile-content-block--user-info bzfy-pack__item">
      {settings.displayName ? (
        <Fragment>
          <div className="bzfy-o-visually-hidden">
            {settings.locale.getTranslation('postPublishedBy')}
          </div>
          <div className="bzfy-c-tilegrid-post__profile-name" style={{ color: settings.postColor }}>
            {getUsername(post)}
          </div>
        </Fragment>
      ) : null}
      {settings.postAge && (
        <div style={{ color: settings.postColor }}>{localizedPostTime(post, settings.locale)}</div>
      )}
    </div>
  )
}

UserRealName.propTypes = {
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
